export class Helper {
    static AreDatesEqual = (date1, date2) => {
        var dt1 = { ...date1 };
        if (Object.prototype.toString.call(dt1) !== '[object Date]') {
            dt1 = new Date(date1);
        }
        var dt2 = { ...date2 };
        if (Object.prototype.toString.call(dt2) !== '[object Date]') {
            dt2 = new Date(date2);
        }
        dt1.setHours(0, 0, 0, 0)
        dt2.setHours(0, 0, 0, 0)
        return dt1.getDate() === dt2.getDate() && dt1.getMonth() === dt2.getMonth() && dt1.getFullYear() === dt2.getFullYear();
    }

    static CompareDates = (date1, date2) => {
        var dt1 = { ...date1 };
        if (Object.prototype.toString.call(dt1) !== '[object Date]') {
            dt1 = new Date(date1);
        }
        var dt2 = { ...date2 };
        if (Object.prototype.toString.call(dt2) !== '[object Date]') {
            dt2 = new Date(date2);
        }
        dt1.setHours(0, 0, 0, 0)
        dt2.setHours(0, 0, 0, 0)
        return dt1 > dt2 ? 1 : (Helper.AreDatesEqual(dt1, dt2) ? 0 : -1);
    }

    static GetNiceDate = (date) => {
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var dayName = days[date.getDay()];

        var mlist = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var monthName = mlist[date.getMonth()];
        return dayName + ', ' + monthName + ' ' + ("0" + date.getDate()).slice(-2) + " " + date.getFullYear();
    }

    static CurrencyFormat = (num, showZero) => {
        if (num) {
            return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
        else if (showZero)
            return '$0.00'
        else
            return '';
    }
}


// WEBPACK FOOTER //
// ./src/components/Helper.jsx